import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 24px;
  background: var(--bg-sidebar);
  border-top: 1px solid var(--border-primary);
  color: var(--text-secondary);
  font-size: 13px;
  font-family: 'Inter', sans-serif;
  box-sizing: border-box;
  z-index: 10;
  position: relative;
  flex-shrink: 0;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 14px 16px;
    gap: 10px;
    text-align: center;
  }
`;

const Copyright = styled.span`
  color: var(--text-secondary);
  font-weight: 400;
  font-size: 13px;
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
  }
`;

const FooterLink = styled.a`
  color: var(--text-secondary);
  text-decoration: none;
  transition: color 0.2s ease;
  font-weight: 500;
  font-size: 13px;

  &:hover {
    color: var(--brand-gold);
  }
`;

const FooterDivider = styled.span`
  color: var(--border-primary);
  user-select: none;
`;

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer className="global-footer">
      <Copyright>
        © {currentYear} Proxy Printery. All rights reserved.
      </Copyright>
      <FooterLinks>
        <FooterLink href="/terms-of-service">Terms of Service</FooterLink>
        <FooterDivider>·</FooterDivider>
        <FooterLink href="/privacy-policy">Privacy Policy</FooterLink>
        <FooterDivider>·</FooterDivider>
        <FooterLink href="/cookie-policy">Cookie Policy</FooterLink>
        <FooterDivider>·</FooterDivider>
        <FooterLink href="/dmca">DMCA</FooterLink>
        <FooterDivider>·</FooterDivider>
        <FooterLink href="mailto:contact@proxyprintery.com">Contact Us</FooterLink>
      </FooterLinks>
    </FooterContainer>
  );
};
